.menu {
    outline: none;
    display: flex;
    flex-direction: column;
    gap: var(--base-menu-item-gap, 10px);
}

.separator {
    height: 1px;
    background-color: var(--colorBorderPrimary);
    margin: var(--spacing-xs) 0;
}

.menuSection {
    display: flex;
    flex-direction: column;
}

.menuSectionHeader {
    padding-block: var(--spacing-xs);
    font-family: var(--fontFamilySansMedium), sans-serif;
    line-height: 1.25;
    font-size: 14px;
    color: var(--colorTextPrimary);
}

.menuLayout {
    display: grid;
    gap: var(--base-menu-layout-gap, var(--spacing-sm));
}

.menuHeader {
    display: flex;
    flex-direction: column;
    /* Break grid-item min-width: auto so descendants with white-space: nowrap don't push the
       header (and the popover with it) wider than its allocated grid track. */
    min-width: 0;
}

/* MenuItemButton: icon + label layout with focus ring and destructive variant */
.menuItemButton {
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);
    padding: var(--spacing-xxs) var(--spacing-xs);
    margin-inline: var(--menu-item-button-margin-inline, 0);
    cursor: pointer;
    outline: none;
    font-family: var(--fontFamilySansMedium), sans-serif;
    font-size: 14px;
    line-height: 1.25;
    color: var(--colorTextPrimary);
    border: 1px solid transparent;
    border-radius: 32px;
}

.menuItemButton[data-hovered],
.menuItemButton[data-pressed] {
    opacity: 0.7;
}

.menuItemButton[data-focus-visible] {
    border-color: var(--colorBorderAccent);
}

.menuItemButton[data-disabled] {
    opacity: 0.4;
    cursor: default;
}

.destructive {
    color: var(--colorTextWarning);
}
